import { render } from "./SportsMeetingDetail.vue?vue&type=template&id=619d25be&scoped=true"
import script from "./SportsMeetingDetail.vue?vue&type=script&lang=js"
export * from "./SportsMeetingDetail.vue?vue&type=script&lang=js"

import "./SportsMeetingDetail.vue?vue&type=style&index=0&id=619d25be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619d25be"]])

export default __exports__